var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithDrawHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12h6.5A3.5 3.5 0 0013 8.5v0A3.5 3.5 0 009.5 5H4m0 0l2.333-2.333M4 5l2.333 2.333",
    stroke: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMgMTJMOS41IDEyQzExLjQzMyAxMiAxMyAxMC40MzMgMTMgOC41VjguNUMxMyA2LjU2NyAxMS40MzMgNSA5LjUgNUw0IDVNNCA1TDYuMzMzMzMgMi42NjY2N000IDVMNi4zMzMzMyA3LjMzMzMzIiBzdHJva2U9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgWithDrawHover as ReactComponent };